module.exports = __webpack_public_path__ + "images/line_lp/header-main_1d0950f975a8c28949ff7f1896fbb7a1.png";